import { useRef, useEffect } from 'react';
import { I } from '../data/tokens';
import { CASE_STUDIES } from '../data';
import CaseStudyCloud  from './CaseStudyCloud';
import CaseStudyConv   from './CaseStudyConv';
import CaseStudyDrone  from './CaseStudyDrone';
import CaseStudyRocket from './CaseStudyRocket';

const PANELS = [CaseStudyCloud, CaseStudyConv, CaseStudyDrone, CaseStudyRocket];

export default function CaseStudyDetail({ project, index, total, onClose, onNext, onPrev }) {
  const scrollRef = useRef(null);
  const Panel = PANELS[index] || PANELS[0];

  useEffect(() => {
    if (scrollRef.current) scrollRef.current.scrollTop = 0;
  }, [project.title]);

  return (
    <div style={I.detailWrapper} className="detail-enter detail-wrapper">

      {/* Top bar */}
      <div style={I.detailTopBar} className="detail-top-bar">
        <button style={I.detailBackBtn} onClick={onClose}>
          <span>←</span>
          <span>Back to projects</span>
        </button>
        <span style={I.detailCounterText}>
          {String(index + 1).padStart(2, '0')} / {String(total).padStart(2, '0')}
        </span>
      </div>

      {/* Scrollable body */}
      <div ref={scrollRef} style={I.detailScroll}>
        <Panel />
      </div>

      {/* Bottom nav */}
      <div style={I.detailNav} className="detail-nav-pad">
        <button style={I.detailNavBtn} onClick={onPrev}>
          <span style={I.navArrow}>←</span>
          <div style={I.navBtnInfo}>
            <span style={I.navBtnSublabel}>Previous</span>
            <span style={I.navBtnTitle} className="nav-btn-title">
              {CASE_STUDIES[(index - 1 + CASE_STUDIES.length) % CASE_STUDIES.length].title}
            </span>
          </div>
        </button>

        <div style={I.dotRow} className="dot-row">
          {Array.from({ length: total }).map((_, i) => (
            <div key={i} style={{ ...I.dot, width: i === index ? '20px' : '6px', background: i === index ? '#1A1A1A' : 'rgba(0,0,0,0.15)' }} />
          ))}
        </div>

        <button style={{ ...I.detailNavBtn, flexDirection: 'row-reverse' }} onClick={onNext}>
          <span style={I.navArrow}>→</span>
          <div style={{ ...I.navBtnInfo, textAlign: 'right' }}>
            <span style={I.navBtnSublabel}>Next</span>
            <span style={I.navBtnTitle} className="nav-btn-title">
              {CASE_STUDIES[(index + 1) % CASE_STUDIES.length].title}
            </span>
          </div>
        </button>
      </div>
    </div>
  );
}
